import { createSlice } from '@reduxjs/toolkit';
import { doCreateOffSchedule, doGetOffSchedule, doUpdateOffSchedule } from './thunk';

const isActionWithPending = (action) => {
  return action.type && action.type.startsWith('off-schedules/') && action.type.endsWith('/pending');
};

const isActionWithFulfilled = (action) => {
  return action.type && action.type.startsWith('off-schedules/') && action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action) => {
  return action.type && action.type.startsWith('off-schedules/') && action.type.endsWith('/rejected');
};

const offScheduleSlice = createSlice({
  name: 'offSchedule',
  initialState: {
    action: null,
    isFetching: false,
    status: 'idle',
    metadata: {},
    offSchedule: null,
  },
  reducers: {
    clearState: (state) => {
      state.offSchedule = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doGetOffSchedule.pending, (state) => {
      state.action = 'getOne';
      state.status = 'loading';
    });
    builder.addCase(doGetOffSchedule.fulfilled, (state, action) => {
      const offSchedule = action.payload;
      state.status = 'succeeded';

      if (!offSchedule?.id) {
        state.offSchedule = null;
      } else {
        state.offSchedule = offSchedule;
      }
    });
    builder.addCase(doGetOffSchedule.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doCreateOffSchedule.pending, (state) => {
      state.action = 'create';
      state.status = 'loading';
    });
    builder.addCase(doCreateOffSchedule.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doCreateOffSchedule.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doUpdateOffSchedule.pending, (state) => {
      state.action = 'update';
      state.status = 'loading';
    });
    builder.addCase(doUpdateOffSchedule.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doUpdateOffSchedule.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
      state.message = null;
    });
  },
});

const { actions, reducer: offScheduleReducer } = offScheduleSlice;
export const { clearState } = actions;
export default offScheduleReducer;
